module.exports = __webpack_public_path__ + "img/FR14706.f8364988.png";